module.exports = __webpack_public_path__ + "static/media/judge.d2bc7a31.png";